import View from '../core/View';
import DropdownMenuView from './DropdownMenuView';

export default class SimpleToolbarView extends View {

    createView(model) {

        let libraryCatalog = model['libraryCatalog'];
        let visualTemplate = model['visualTemplate'];

        let toolbarDOM = $('<div>', {
            class: 'toolbar',
            css: {
                'margin': '0px',
                'padding': '8px',
                'width': '100%',
                'height': '40px',
                'background-color': visualTemplate.toolbarBackgroundColor
            }
        });

        // Back button
        if (!libraryCatalog.useAsRoot && libraryCatalog.showExitButton) {
            let btnName = this.app.polyglot.t("Back");
            $('<button>', {
                class: 'btn btn-xs btn-default',
                css: {
                    'background-color': `${visualTemplate.toolbarBackgroundColor}`,
                    'color': `${visualTemplate.toolbarTintSecondaryColor}`,
                    'border': '0px',
                    'font-size': '16px',
                    'font-weight': 'bold',
                    'float': 'left'
                },
                text: btnName,
                click: this.onBackButtonPressed.bind(this)
            }).appendTo(toolbarDOM);
        }

        // Toolbar title
        $('<h1>', {
            text: libraryCatalog.title,
            css: {
                'margin': '0px',
                'text-align': 'center',
                'font-size': '1.5em',
                'color': visualTemplate.toolbarTintColor
            }
        }).appendTo(toolbarDOM);

        $('<div>', {
            css: {
                'clear': 'both'
            }
        }).appendTo(toolbarDOM);

        return toolbarDOM;

    }

    onBackButtonPressed() {
        this.app.goBack();
    }

}
